import { STATUS_TYPE } from '../../../enum';
import { PropertyCategory } from '../../propertyCategory/api/interface';
import { PropertyFacility } from '../../propertyFacility/api/interface';
import { PropertyFeature } from '../../propertyFeature/api/interface';

export interface PropertyFacilitySubCategoryMapper {
  id: string;
  propertyFacilityId: string;
  propertySubCategoryId: string;
  property_facility: PropertyFacility;
}

export interface PropertyFeatureSubCategoryMapper {
  id: string;
  propertyFeatureId: string;
  propertySubCategoryId: string;
  property_feature: PropertyFeature;
}
export interface GetPropertySubCategory {
  id: string;
}

export interface FindPropertySubCategory {
  activeOnly?: boolean;
  categoryId?: string;
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchPropertySubCategory {
  id?: string;
  labelEn: string;
  labelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  propertyCategoryId: string;
  propertyFeatureIds: string[];
  propertyFacilityIds: string[];
}

export interface PropertySubCategory {
  id: string;
  labelEn: string;
  labelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  propertyCategoryId: string;
  property_category: PropertyCategory;
  propertyFacilitySubCategoryMapper: PropertyFacilitySubCategoryMapper[];
  propertyFeatureSubCategoryMapper: PropertyFeatureSubCategoryMapper[];
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: PropertySubCategory[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
